import { Button } from '@carnica/ui-kit';
import { IconPlusRoundStroked } from '@carnica/graphics';
import React, { ComponentProps } from 'react';
import classNames from 'classnames/bind';
import { withRenderFlag } from '@beef/react';
import { cnComponentsTheme } from '@carnica/ui-kit/styles';

import { ReplenishButtonType, getReplenishLink } from 'utils';

import styles from './styles.pcss';

const cn = classNames.bind(styles);

export const _ReplenishmentButton: React.FC<{
  isSvyazZ: boolean;
  replenishButtonType?: ReplenishButtonType;
  tariffUrl: string;
}> = ({ replenishButtonType, tariffUrl, isSvyazZ }) => {
  const handleAddClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (replenishButtonType) {
      window.location.href = getReplenishLink(replenishButtonType, tariffUrl, isSvyazZ);
    }
  };

  return (
    <Button
      className={cn('buy', cnComponentsTheme('light'))}
      onClick={handleAddClick}
      size="l"
      type="button"
      view="primary"
    >
      <IconPlusRoundStroked size={20} />
    </Button>
  );
};

export const ReplenishmentButton: React.FC<
  {
    shouldRender: boolean;
  } & ComponentProps<typeof _ReplenishmentButton>
> = withRenderFlag(_ReplenishmentButton);
